// On a touch device, the order of events
// fired on a touch tap are as follows:
//
// - touchstart
// - touchend
// - mouseenter
// - mousemove
// - mousedown
// - mouseup
// - click
//
// If this is a touch tap, we want to cancel
// the mouse events (i.e. preventDefault) so
// that we do not bubble up mouseenter to the
// parent element and then also fire a click
// (which was causing a double toggle bug)
export function onTouchOrClick(element, callback) {
    let isTouching = false;
    function onTouchStart() {
        isTouching = true;
    }
    function onTouchCancel() {
        isTouching = false;
    }
    function onTouchEnd(e) {
        if (isTouching) {
            e.preventDefault();
            callback();
        }
    }
    element.addEventListener('click', callback);
    element.addEventListener('touchstart', onTouchStart, { passive: true });
    element.addEventListener('touchmove', onTouchCancel, { passive: true });
    element.addEventListener('touchcancel', onTouchCancel, { passive: true });
    element.addEventListener('touchend', onTouchEnd);
    return {
        destroy() {
            element.removeEventListener('click', callback);
            element.removeEventListener('touchstart', onTouchStart);
            element.removeEventListener('touchmove', onTouchCancel);
            element.removeEventListener('touchcancel', onTouchCancel);
            element.removeEventListener('touchend', onTouchEnd);
        },
    };
}
